import { apiGet, apiPost } from "./apiClient";

/** Single React Query key for mailbox list (sidebar, settings, onboarding). */
export const mailboxesQueryKey = ["mailboxes"];

export const mailboxService = {
  list,
  start,
  disconnect,
  setPrimary,
  clearImported,
};

function list() {
  return apiGet("/api/v1/mailbox/");
}

function start(payload = {}) {
  return apiPost("/api/v1/mailbox/start/", payload);
}

function disconnect(hash) {
  return apiPost(`/api/v1/mailbox/${hash}/disconnect/`, {});
}

function setPrimary(hash) {
  return apiPost(`/api/v1/mailbox/${hash}/set-primary/`, {});
}

function clearImported(hash) {
  return apiPost(`/api/v1/mailbox/${hash}/clear-imported/`, {});
}
